module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"unlockContent":"Inhalt freischalten"},"en":{"unlockContent":"Unlock content"}}')
  delete Component.options._Ctor
}
